module.exports = __webpack_public_path__ + "static/media/배너 제작.e8742d1e.jpg";